import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';
import cloneDeep from 'lodash/cloneDeep';
import {
  MessageDialogObject,
  MessageDialogList,
  MessageConfirmObject,
  MessageConfirmList,
  MessageSnackObject,
  MessageSnackList
} from './types';

class Message extends Immerable {
  public messageDialogList: MessageDialogList;

  public messageConfirmList: MessageConfirmList;

  public messageSnackList: MessageSnackList;

  public constructor() {
    super();
    this.messageDialogList = {
      list: []
    };
    this.messageConfirmList = {
      list: []
    };
    this.messageSnackList = {
      list: []
    };
  }

  public initialize(): void {
    this.messageDialogList = {
      list: []
    };
    this.messageConfirmList = {
      list: []
    };
    this.messageSnackList = {
      list: []
    };
  }

  public updateMessageDialogList(newMessageDialogObject: MessageDialogObject): void {
    const newCloneMessageDialogObject = newMessageDialogObject;
    const newCloneMessageDialogList = cloneDeep(this.messageDialogList);
    newCloneMessageDialogList.list.push(newCloneMessageDialogObject);
    this.messageDialogList = newCloneMessageDialogList;
  }

  public removeMessageDialog(): void {
    const newCloneMessageDialogList = cloneDeep(this.messageDialogList.list);
    const newSliceDialogList = newCloneMessageDialogList.slice(1);
    this.messageDialogList.list = newSliceDialogList;
  }

  public updateMessageConfirmList(newMessageConfirmObject: MessageConfirmObject): void {
    const newCloneMessageConfirmObject = newMessageConfirmObject;
    const newCloneMessageConfirmList = cloneDeep(this.messageConfirmList);
    newCloneMessageConfirmList.list.push(newCloneMessageConfirmObject);
    this.messageConfirmList = newCloneMessageConfirmList;
  }

  public removeMessageConfirm(): void {
    const newCloneMessageConfirmList = cloneDeep(this.messageConfirmList.list);
    const newSliceConfirmList = newCloneMessageConfirmList.slice(1);
    this.messageConfirmList.list = newSliceConfirmList;
  }

  public updateMessageSnackList(newMessageSnackObject: MessageSnackObject): void {
    const newCloneMessageSnackObject = newMessageSnackObject;
    const newCloneMessageSnackList = cloneDeep(this.messageSnackList);
    newCloneMessageSnackList.list.push(newCloneMessageSnackObject);
    this.messageSnackList = newCloneMessageSnackList;
  }

  public removeMessageSnack(): void {
    const newCloneMessageSnackList = cloneDeep(this.messageSnackList.list);
    const newSliceSnackList = newCloneMessageSnackList.slice(1);
    this.messageSnackList.list = newSliceSnackList;
  }
}

export default Message;
